import { all } from "redux-saga/effects";
import * as CountriesSaga from "./countriesSaga";
import * as EventsSaga from "./eventsSaga";
import * as AtheleteSaga from "./atheleteSaga";
import * as SchoolSaga from "./schoolSaga";
import * as DisclaimersSaga from "./disclaimerSaga";
function* Sagas() {
  yield all([
    CountriesSaga.watcherSaga(),
    EventsSaga.watcherSaga(),
    AtheleteSaga.watcherSaga(),
    SchoolSaga.watcherSaga(),
    DisclaimersSaga.watcherSaga()
  ]);
}

export default Sagas;
